<!--
구매단가 인라인 수정 컴포넌트 (TASK-161 구매요청 페이지 — prod/buy-order-code.vue 패턴)
------------------------------------
 - ENTER 또는 「입력」 버튼 → PATCH /admin/buy-requests/prods/{prodId}/buy-unit-price
 - 실패 = 서버 메세지 alert ($.app.ajax.module.default 기본 처리)
-->
<template>
    <div :class="classObject">
        <div class="uk-flex uk-flex-middle uk-flex-center">
            <input class="uk-width-expand uk-text-right" type="text" v-model.trim="inputBuyUnitPrice" @keyup.enter="submit"
                   placeholder="구매단가" :title="'구매단가 (' + (currency || '-') + ') : ENTER입력시 저장'"/>
            <span class="currency" v-if="currency">{{ currency }}</span>
            <button class="uk-button uk-button-small uk-button-dg-w-dg" type="button" @click="submit" v-if="edited">입력</button>
            <i class="material-icons md-24 check" v-if="saved && edited === false">check</i>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 상품ID
            prodId: Number,

            // 구입단가 (현지통화)
            buyUnitPrice: {
                type: [String, Number],
                default: '',
            },

            // 현지통화 (buy_unit_price_currency)
            currency: {
                type: String,
                default: '',
            },
        },
        data: function () {
            let initial = (this.buyUnitPrice === null || this.buyUnitPrice === undefined) ? '' : String(this.buyUnitPrice);
            return {
                // (string) 수정전 원본값
                oldBuyUnitPrice: initial,

                // (string) 입력값
                inputBuyUnitPrice: initial,

                // (bool) 저장완료여부
                saved: false,

                // (bool) 저장중
                saving: false,
            };
        },
        computed: {
            /**
             * 수정여부
             * @return boolean
             */
            edited() {
                return this.oldBuyUnitPrice !== this.inputBuyUnitPrice;
            },

            /**
             * 컴포넌트 전체에 대한 css 클래스
             * @return Object
             */
            classObject() {
                return {
                    'edited': this.edited,
                    'saved': this.saved,
                };
            },
        },
        methods: {
            /**
             * submit
             */
            submit() {
                if (this.saving || ! this.edited) {
                    return;
                }
                this.saving = true;

                let load = new Promise((resolve, reject) => {
                    let opts = {
                        type: 'patch',
                        url: '/admin/buy-requests/prods/' + this.prodId + '/buy-unit-price',
                        dataType: 'json',
                        data: {
                            _token: this.csrfToken,
                            buy_unit_price: this.inputBuyUnitPrice,
                        },
                        success: (response, textStatus, jqXHR) => {
                            resolve(response);
                        },
                        complete: () => {
                            this.saving = false;
                        },
                    };
                    $.app.ajax.module.default(opts);
                });

                load.then((response) => {
                    let saved = (response && response.buy_unit_price !== null && response.buy_unit_price !== undefined)
                        ? String(response.buy_unit_price)
                        : this.inputBuyUnitPrice;
                    this.inputBuyUnitPrice = saved;
                    this.oldBuyUnitPrice = saved;
                    this.saved = true;

                    // B3: 구매정보저장 모달 기본 합계 소스 (page.batch.items) 동기
                    let items = (this.$root.page && this.$root.page.batch && this.$root.page.batch.items) || [];
                    items.forEach((item) => {
                        if (parseInt(item.id, 10) === this.prodId) {
                            item.buy_unit_price = saved;
                        }
                    });
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    input {
        font-size: 1rem;
        padding: 1px 4px;
        height: 1.75rem;
        min-width: 5rem;
    }
    button {
        font-size: 1rem;
        padding: 1px 4px;
        height: 1.75rem;
        line-height: 1.75rem;
    }
    .currency {
        margin-left: 2px;
        color: #666;
    }

    // 저장됨
    .saved {
        input {
            border: 1px solid mediumseagreen !important;
        }
    }

    // 수정됨
    .edited {
        input {
            border: 1px solid red !important;
        }
        button {
            border: 1px solid red !important;
            color: red !important;
        }
    }

    .check {
        color: mediumseagreen !important;
    }
</style>
